import { render, staticRenderFns } from "./GradingPlanSlicesDataComponent.vue?vue&type=template&id=238faeca&"
import script from "./GradingPlanSlicesDataComponent.vue?vue&type=script&lang=js&"
export * from "./GradingPlanSlicesDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports